import { createElement } from '../modules/globalFunctions'

// blog on homepage - changes title and buttons text, moves the block, adds a button for all articles
const blogOnHomepage = () => {
	const blogBlock = document.querySelector('.homepage-blog-wrapper')
	if (!blogBlock) return
	const benefitBanner = document.querySelector('.container > .welcome-wrapper')
	if (benefitBanner) benefitBanner.after(blogBlock)
	const blogBlockTitle = blogBlock.querySelector('.homepage-group-title')
	const blogBlockButton = blogBlock.querySelector('.btn')
	if (blogBlockTitle) blogBlockTitle.textContent = 'Rady a blogy'
	const blogBlockButtonWrapper = createElement('div', ['button-wrapper'])
	const blogBlockButtonAll = createElement('a', ['btn', 'btn-secondary'], 'Zobrazit blog')
	blogBlockButtonAll.href = '/rady-a-blogy'
	blogBlockButtonWrapper.appendChild(blogBlockButtonAll)
	blogBlock.appendChild(blogBlockButtonWrapper)

	const newsItems = blogBlock.querySelectorAll('.news-item')
	for (const newsItem of newsItems) {
		const newsItemButton = newsItem.querySelector('.read-article')
		if (newsItemButton) newsItemButton.textContent = 'Číst dále'
	}
}

const addLinkToArticles = () => {
	const newsItems = document.querySelectorAll('.news-item')
	for (const newsItem of newsItems) {
		const newsItemLink = newsItem.querySelector('a.title')
		if (newsItemLink) {
			const addedLink = createElement('a', ['read-article'], window.language === 'cs' ? 'Přečíst článek' : 'Prečítať článok')
			addedLink.href = newsItemLink.href
			const text = newsItem.querySelector('.text')
			if (text) text.appendChild(addedLink)
		}
	}
}
export { blogOnHomepage, addLinkToArticles }
